import { render, staticRenderFns } from "./DetalhesBudget.vue?vue&type=template&id=66c4352f&"
import script from "./DetalhesBudget.vue?vue&type=script&lang=js&"
export * from "./DetalhesBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports